'use strict';

import toasts from './toast-notify';

// Advent Calendar Start
function handleAdventCalendar() {
    $(document).ready(function() {
        setTimeout(function() {
            $('.offerWrapper').css('display','none');
            var unlockedState = $('.unlockedCellImage');
            var adventSlider = $('.calendar_cells');
            // Advent Calendar Start
            if($(window).innerWidth() <= 767 && $(window).innerWidth() !==0) {
                adventSlider.slick({
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    infinite: true,
                    variableWidth: true,
                    centerMode: true,
                    dots: true,
                    arrows: false,
                    dotsClass: 'slider-dots',
                });
                var activeSlideNumber=$('.unlockedCellImage').closest('.slick-slide').not('.slick-cloned').first().data('slick-index')
                adventSlider.slick('slickGoTo', activeSlideNumber);  // navigate to random slide;       
                adventSlider.slick('slickSetOption', 'speed', 0);
                adventSlider.on('afterChange',function(){
                    var offerMobile= $('.slick-active').siblings().find('.offer-mobile');
                    offerMobile.height(0);
                    offerMobile.removeClass('open');
                    var unlockedImages = $('.slick-active').siblings().find('.unlockedCellImage img');
                    unlockedImages.attr('src',unlockedImages.data('unlock-src'));
                    $('.slick-active').siblings().find('.unlockedCellImage').removeClass('unlocked-cell-image-open');
                });
            } else {
                unlockedState.each(function(index,value) {
                    $(this).attr('data-toggle', 'modal');
                    $(this).attr('data-target', '#offerModal-'+index);
                    $(this).closest('.stateCell').find('.offerWrapper').attr('id', 'offerModal-'+index)
                });
            }
        }, 0);
    });

    $('.calendarlayout').on('click', '.unlockedCellImage', function() {
        var $this = $(this);
        var unlockImageSrc = $this.find('img').data('unlock-src');
        if($(window).width() > 767){
            $this.closest('.stateCell').find('.offerWrapper').css('display', 'block');
        }else{
            var offerMobile = $this.closest('.stateCell').find('.offer-mobile');
            var offerWrapper = $this.closest('.stateCell').find('.offer-mobile .offer-wrapper');
            if(offerMobile.hasClass('open')) {
                offerMobile.removeClass('open');
                offerMobile.height(0);
                $this.find('img').attr('src',unlockImageSrc);
                $this.removeClass('unlocked-cell-image-open');
                offerWrapper.css('visibility','collapse');
            } else {
                offerMobile.addClass('open');
                offerMobile.height(offerWrapper.outerHeight(true));
                offerWrapper.css('visibility','visible');
                var mobileUnlockToggleImg = $this.find('img').data('src-toggle');
                $this.addClass('unlocked-cell-image-open');
                mobileUnlockToggleImg !=null ? $this.find('img').attr('src',mobileUnlockToggleImg) : $this.find('img').attr('src',unlockImageSrc);
            }
        }
    });
    // copy/paste promo code on all banners functionality
    $('.calendarlayout').on('click keypress', '.copy-icon', function(e) {
        if(e.type === 'click' || (e.type === 'keypress' && e.key === 'Enter')) {
            var textToCopy = $(this).parent().text();
            navigator.clipboard.writeText(textToCopy).then(
                toasts.init($('#clicktocopyadvent').val(), 'active animate__fadeInDownToast', 'icon icon-clickToCopy')
            )
        }
    });
    $('.calendarlayout').on('click', '.close-icon', function() {
        $('.offerWrapper').css('display','none');
    });
}
// Advent Calendar end

var adventCalendarBlock = {	
    init: function () {
        handleAdventCalendar();
    }
};

export default adventCalendarBlock;
